import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { AuthenticationService } from '../authentication.service';
import type { SignInOutcome, TwoFactorEnrollment } from '../authentication.types';

@Injectable()
export class AuthenticationDisabledService extends AuthenticationService {
  signIn(): Observable<SignInOutcome> {
    return of({ status: 'signed-in' });
  }

  verifySecondFactor(): Observable<boolean> {
    return of(true);
  }

  startTwoFactorEnrollment(): Observable<TwoFactorEnrollment> {
    return of({ otpauthUri: '', secret: '' });
  }

  confirmTwoFactorEnrollment(): Observable<string[]> {
    return of([]);
  }

  signOut(): Observable<boolean> {
    return of(true);
  }

  signUp(): Observable<boolean> {
    return of(true);
  }

  forgotPassword(): Observable<boolean> {
    return of(true);
  }

  resetPassword(): Observable<boolean> {
    return of(true);
  }

  check(): Observable<boolean> {
    return of(true);
  }

  impersonate(): Observable<boolean> {
    return of(true);
  }

  stopImpersonation(): Observable<boolean> {
    return of(true);
  }
}
